/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fa-exclamation-circle[_ngcontent-%COMP%], .textRed[_ngcontent-%COMP%]{color:#c00}.textUnderlined[_ngcontent-%COMP%]{text-decoration:underline;-webkit-text-decoration-style:dashed;text-decoration-style:dashed}"];
export { styles as styles };
